import { createFileRoute } from '@tanstack/react-router';
import { PlanDetail } from '@/components/Modules/ReadingPlans';

export const Route = createFileRoute('/plans/$id')({
  component: PlanDetail,
});
